import { Component, computed } from '@angular/core';
import { Subscription } from 'rxjs';
import { PatientService } from '../../services/patient/patient-info.service';
import { PatientInfoAPI } from 'src/app/features/medical-record/medical-record-page/pages/patient-informations/model/patient.model';
import { MedicalRecordState } from 'src/app/features/medical-record/store/medical-record.state';
import { Store } from '@ngrx/store';
import { getAuthStateSelect } from 'src/app/core/store/auth/auth.selector';
import { IUser, UserPermission } from 'src/app/core/models/user.model';
import { MedicalTab, allMedicalTabsMap, medicalTabs, questionnariesTabsMap } from './tabs';
import { TabsStateService } from 'src/app/features/medical-record/services/tabs-state.service';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent {


  allTabs: MedicalTab[] = [...medicalTabs];
  tabs: MedicalTab[] = [...medicalTabs];
  tabSelected = computed(() => this.tabsStateService.currentTab() )
  subscription: Subscription = new Subscription();
  patient: PatientInfoAPI | null = null;
  userLogged? : IUser | null;
  permissions?: UserPermission

  constructor(
    private store: Store<MedicalRecordState>,
    private patientInfoService: PatientService,
    private tabsStateService: TabsStateService,
    ) {

    this.store
      .select(getAuthStateSelect)
      .subscribe((user) => {
        this.permissions = user?.user?.permission;
        this.tabs = this.calcVisibleTabs()
    });


    this.subscription = this.patientInfoService.selectedPatientObs.subscribe(patient => {
      if (patient) {
        this.patient = patient;
        this.tabs = this.calcVisibleTabs()
      }
    });


  }
  ngOnInit(): void {
    this.plataform=(window.navigator.platform)
  }

  plataform: string = ""

  filterByUserPermission(tabs:  MedicalTab[]) {
    if (!this.permissions ) {
      return tabs;
    }
    return tabs.filter( tab => {
      const tabKey = allMedicalTabsMap[tab];
      const permissionCode = this.permissions![tabKey] ?? 'rw';
      return permissionCode.includes('r');
    } )
  }

  removeEvolutionIfNeeded(tabs: MedicalTab[]) {
    if (!this.patient) {
      return tabs;
    }
    if (
      this.patient.patientMedicalRecord.diagnosisStatus.toLowerCase() === 'inicial' ||
      this.patient.patientMedicalRecord.diagnosisStatus.length === 0 ||
      this.patient.patientMedicalRecord.diagnosisStatus.toLowerCase() === 'primeira consulta'
    ) {
      return tabs.filter( tab => tab !== 'evolução' )
    }
    return tabs;
  }

  calcVisibleTabs() {
    const firstFilter = this.filterByUserPermission([...medicalTabs]);
    const secondFilter = this.removeEvolutionIfNeeded(firstFilter);
    return secondFilter
  }

  ngOnDestroy() {

    this.subscription.unsubscribe();
  }

  clickTab(tab: MedicalTab) {
    this.tabsStateService.changeTab(tab)
  }
}


